import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';

import { InvoiceBannerButtonDirective } from './invoice-detail-banner-button.directive';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [
    {
      directive: InvoiceBannerButtonDirective,
      inputs: ['invoice'],
    },
  ],
  imports: [ButtonComponent],
  selector: 'aux-invoice-detail-status-banner-download-button',
  template: `
    <aux-button
      [onClick]="onDownloadInvoice"
      icon="Download"
      variant="secondary"
      classList="bg-white"
      label="Download Invoice"
    />
  `,
})
export class InvoiceDetailDownloadBtnComponent {
  ctx = inject(InvoiceBannerButtonDirective);

  onDownloadInvoice = async () => {
    const { invoiceQuery, overlayService } = this.ctx;
    const invoice = this.ctx.invoice();
    const { data, errors, success } = await invoiceQuery.downloadINV(invoice.id);

    if (success && data) {
      overlayService.success();
    } else {
      overlayService.error(errors);
    }
  };
}
